var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6L14.7173 11.7173C14.7545 11.7544 14.784 11.7985 14.8041 11.847C14.8242 11.8955 14.8345 11.9475 14.8345 12C14.8345 12.0525 14.8242 12.1045 14.8041 12.153C14.784 12.2015 14.7545 12.2456 14.7173 12.2827L9 18",
    stroke: "#9DA1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronInactive);
export default __webpack_public_path__ + "static/media/ChevronInactive.dae877e6a6831cee8c18963947131b9c.svg";
export { ForwardRef as ReactComponent };